<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.652"
      height="17.491"
      viewBox="0 0 19.652 17.491"
      class="scaling-svg"
    >
      <g id="Group_97" data-name="Group 97" transform="translate(-50.5 -579.85)">
        <g id="Group_96" data-name="Group 96" transform="translate(0 236.841)">
          <g id="Icon_mail_open" transform="translate(49 344)">
            <g id="Icon_mail_open-2" data-name="Icon_mail_open" transform="translate(1.5 1.5)">
              <path
                id="Shape"
                d="M14.25,15H.75A.751.751,0,0,1,0,14.25v-9a.749.749,0,0,1,.334-.624l6.75-4.5a.749.749,0,0,1,.832,0l6.75,4.5A.748.748,0,0,1,15,5.25v9A.751.751,0,0,1,14.25,15ZM1.5,6.651V13.5h12V6.651L7.916,10.374a.749.749,0,0,1-.832,0Zm6-5L2.1,5.25l5.4,3.6,5.4-3.6-5.4-3.6Z"
                fill="#534d69"
              />
            </g>
          </g>
        </g>
        <g id="Icon_view" transform="translate(61.807 580.065)">
          <path
            id="Path"
            d="M1.258,2.516A1.258,1.258,0,1,0,0,1.258,1.258,1.258,0,0,0,1.258,2.516Z"
            transform="translate(2.935 1.677)"
            fill="#534d69"
            stroke="#534d69"
            stroke-width="0.3"
          />
          <path
            id="Shape-2"
            data-name="Shape"
            d="M4,6A3.991,3.991,0,0,1,1.105,4.843,4.371,4.371,0,0,1,.02,3.135a.459.459,0,0,1,.008-.295A4.8,4.8,0,0,1,1.13,1.13,3.954,3.954,0,0,1,4,0,3.954,3.954,0,0,1,6.87,1.13a4.8,4.8,0,0,1,1.1,1.711.461.461,0,0,1-.007.337A5.2,5.2,0,0,1,6.844,4.9,3.926,3.926,0,0,1,4,6ZM4,.857a3.238,3.238,0,0,0-2.221.8A3.79,3.79,0,0,0,.831,3.009a3.586,3.586,0,0,0,.935,1.314A3.271,3.271,0,0,0,4,5.143a3.178,3.178,0,0,0,2.306-.879,4.094,4.094,0,0,0,.856-1.271,3.782,3.782,0,0,0-.953-1.341A3.24,3.24,0,0,0,4,.857Z"
            transform="translate(0.193 -0.065)"
            fill="#534d69"
            stroke="#534d69"
            stroke-width="0.3"
          />
        </g>
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class OneMailOpenedByContractorIcon extends Vue {}
</script>

<style>
</style>
